import { render, staticRenderFns } from "./editAdjust.vue?vue&type=template&id=48ebc528&scoped=true&"
import script from "./editAdjust.vue?vue&type=script&lang=js&"
export * from "./editAdjust.vue?vue&type=script&lang=js&"
import style0 from "./editAdjust.vue?vue&type=style&index=0&id=48ebc528&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ebc528",
  null
  
)

export default component.exports